module.exports = __webpack_public_path__ + "img/deer.8a2affa8.png";